import { Component, Input } from '@angular/core';
import { UntypedFormControl, NgModel } from '@angular/forms';
import { getErrorMessage } from 'shared/error-message-helper';

@Component({
  selector: 'app-input-error',
  templateUrl: './input-error.component.html'
})
export class InputErrorComponent {
  @Input() formControlItem: UntypedFormControl | NgModel;
  // TODO: We can use this to add errors to selects or radios
  @Input() formControlType: string;

  /**
   *
   */
  constructor() {  }

  get errorText() {
    const errorMessage = getErrorMessage(this.formControlItem);
    return errorMessage;
  }

}
